import {
  Component,
  Injector,
  Optional
} from '@angular/core';
import {CommonModule} from "@angular/common";
import { WmsTranscludeDirective } from '../../page/wms-transclude/wms-transclude.directive';

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, styler, register } from "@wm/components-base";


const DEFAULT_CLS = 'app-bottomsheet';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-bottomsheet',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: '[wmBottomSheet]',
  template: `
    <div class="app-bottomsheet-root">
      <!-- Backdrop -->
      <div class="app-bottomsheet-backdrop"></div>

      <!-- Bottom Sheet Container -->
      <div class="app-bottomsheet-container">
        
        <!-- Drag Handle -->
        <div class="app-bottomsheet-draghandle-container">
          <div class="app-bottomsheet-drag-icon-handle"></div>
        </div>
        <!-- Content Container -->
        <div class="app-bottomsheet-content-container">
          <div class="app-bottomsheet-content" wmsTransclude>
            <ng-content></ng-content>
          </div>
        </div>
      </div>
    </div>
  `,
  providers: [
    provideAsWidgetRef(BottomSheetComponent)
  ],
  exportAs: 'wmBottomSheet',
  standalone: true,
  imports: [ CommonModule, WmsTranscludeDirective ],
  styles: [
  ]
})
export class BottomSheetComponent extends StylableComponent {
  static initializeProps = register('wm-bottomsheet');
  public expand: boolean;

  constructor(inj: Injector,
    @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }

  protected override onPropertyChange(this: any, key: string, nv: string, ov?: any) {
    var wdgtProperties = this.widgetProps;
    if (key === 'expand') {
      wdgtProperties.bottomsheetexpandedheightratio.show = !!nv;
    } else if (key === 'bottomsheetheightratio') {
      // Convert the ratio to a percentage and ensure it's between 0 and 100
      const ratio = parseFloat(nv);
      if (!isNaN(ratio)) {
        const percentage = Math.min(Math.max(ratio * 100, 0), 100);
        const container = this.nativeElement.querySelector('.app-bottomsheet-container');
        if (container) {
          container.style.height = `${percentage}%`;
        }
      }
    }
    else if (key === 'disableswipedownclose') {
      wdgtProperties.bottomsheetminimumheight.show = !!nv;
    }
    else {
      super.onPropertyChange(key, nv, ov);
    }
  }
}

